import { render, staticRenderFns } from "./Rbac.vue?vue&type=template&id=4b4856dd&scoped=true&"
import script from "./Rbac.vue?vue&type=script&lang=js&"
export * from "./Rbac.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4856dd",
  null
  
)

export default component.exports